import template from "./division-colorpicker.html";
import css from "./division-colorpicker.css";
import {Division} from "gui";

function rgbToHex(r, g, b) {
  r = Math.round(r);
  g = Math.round(g);
  b = Math.round(b);
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);  
}

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

class ColorPicker extends Division {
  static constructor() {
    customElements.define("fulljs-division-colorpicker", ColorPicker);
  }
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static get designer() {
    return({
      "category": "Picker",
      "icon": {"context": "actions", "size": 16, "iconname": "color-picker"}
    });
  }
  static get schema() {
    return({
      "type": "object",
      "description": "ColorPicker control pops up a colorpicker and ask the user the pick a color",
      "properties": {
        "value": {
          "type": "string",
          "description": "",
          "default": "#000000"
        }
      }
    });
  }
  constructor(p) {
    super(p);  
  }
  rangeR_input(event) {    
    this.range_input(event);
  }
  rangeG_input(event) {
    this.range_input(event);
  }
  rangeB_input(event) {
    this.range_input(event);
  }  
  range_input() {
    this.rangeR.label.value = `Red Channel (${this.rangeR.value}%)`;
    this.rangeG.label.value = `Green Channel (${this.rangeG.value}%)`;
    this.rangeB.label.value = `Blue Channel (${this.rangeB.value}%)`; 
    
    if ("createEvent" in document) {
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("input", true, true);
      this.dispatchEvent(evt);
    } else {
      this.fireEvent("oninput");
    }

  }
  rangeR_change(event) {    
    this.range_change(event);
  }
  rangeG_change(event) {
    this.range_change(event);
  }
  rangeB_change(event) {
    this.range_change(event);
  }  
  range_change() {
    if ("createEvent" in document) {
      var evt = document.createEvent("HTMLEvents");
      evt.initEvent("change", true, true);
      this.dispatchEvent(evt);
    } else {
      this.fireEvent("onchange");
    }    
  }
  get value() {
    return rgbToHex(this.rangeR.value*2.55, this.rangeG.value*2.55, this.rangeB.value*2.55);
  }
  set value(hex) {        
    var rgb = hexToRgb(hex);    
    this.rangeR.value = Math.round(rgb.r/2.55);
    this.rangeG.value = Math.round(rgb.g/2.55);
    this.rangeB.value = Math.round(rgb.b/2.55);
    
    this.rangeR.label.value = `Red Channel (${this.rangeR.value}%)`;
    this.rangeG.label.value = `Green Channel (${this.rangeG.value}%)`;
    this.rangeB.label.value = `Blue Channel (${this.rangeB.value}%)`; 
    
  }
  toString() {
    return this.value;
  }
}

ColorPicker.constructor();

export default ColorPicker;